<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle19')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle19') }}</h1>
    <p>{{ $t('artText19-1') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Create_Your_Ultimate_Relaxation_Retreat_Realizing_Master_Bathroom_Ideas_with_DreamFlat.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText19-2') }}</h2>
    <p>{{ $t('artText19-3') }}</p>
    <h2>{{ $t('artText19-4') }}</h2>
    <p>{{ $t('artText19-5') }}</p>
    <h2>{{ $t('artText19-6') }}</h2>
    <p>{{ $t('artText19-7') }}</p>
    <h2>{{ $t('artText19-8') }}</h2>
    <p>{{ $t('artText19-9') }}</p>
    <h2>{{ $t('artText19-10') }}</h2>
    <p>{{ $t('artText19-11') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle19')}`,
  ogTitle: `${t('artSeoTitle19')}`,
  description: `${t('artSeoDesc19')}`,
  ogDescription: `${t('artSeoDesc19')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
